import {CheatDemoController} from './CheatDemoController';
import {CheatPlugin} from '../../CheatModuleInterfaces';
import {CheatFiltersView} from '../filters/CheatFiltersView';

const demo: CheatPlugin = {
    name: 'AM Demo',
    init: () => [
        CheatDemoController,
        CheatFiltersView
    ]
};

export default demo;
